(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-consent"]) return;
  try {
    
  if (!customElements.get('nidoo-cookie-settings')) {
    customElements.define('nidoo-cookie-settings', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('button');
        this.error = this.querySelector('[role="alert"]');
        this.button.addEventListener('click', () => this.openPreferences());
      }

      async openPreferences() {
        if (this.busy) return;
        this.busy = true;
        this.error.hidden = true;
        this.button.setAttribute('aria-busy', 'true');
        let timeout;
        try {
          const opening = async () => {
            const started = Date.now();
            while (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
              if (Date.now() - started > 6000) throw new Error('Privacy banner unavailable');
              await new Promise(resolve => setTimeout(resolve, 150));
            }
            await window.privacyBanner.showPreferences();
          };
          await Promise.race([
            opening(),
            new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Privacy banner timeout')), 10000); })
          ]);
        } catch (error) {
          this.error.hidden = false;
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
